import { TuiEditorTool } from '@taiga-ui/addon-editor/enums';

const defaultEditorColors = new Map([
    [`transparent`, `transparent`],
    [`color-black-300`, `#333333`],
    [`color-black-200`, `#666666`],
    [`color-black-100`, `#909090`],
    [`color-yellow-100`, `#FFDD2C`],
    [`color-yellow-200`, `#FCC521`],
    [`color-yellow-300`, `#FAB618`],
    [`color-gray-100`, `#f5f5f6`],
    [`color-gray-200`, `#e7e8ea`],
    [`color-gray-300`, `#cbcfd3`],
    [`color-gray-400`, `#959ba4`],
    [`color-gray-500`, `#79818c`],
    [`color-gray-600`, `#616871`],
    [`color-light-blue-100`, `#ecf1f7`],
    [`color-light-blue-200`, `#e4ebf3`],
    [`color-light-blue-300`, `#dde4ed`],
    [`color-blue-100`, `#1771e6`],
    [`color-blue-200`, `#1464cc`],
    [`color-blue-300`, `#0953b3`],
    [`color-green-100`, `#39b54a`],
    [`color-green-200`, `#2ca53a`],
    [`color-green-300`, `#168a21`],
    [`color-red-100`, `#e01f19`],
    [`color-red-200`, `#d3120e`],
    [`color-red-300`, `#c40b08`],
]);
const EDITOR_BLANK_COLOR = `rgb(51, 51, 51)`;

const defaultEditorTools = [
    TuiEditorTool.Undo,
    TuiEditorTool.Size,
    TuiEditorTool.Bold,
    TuiEditorTool.Italic,
    TuiEditorTool.Underline,
    TuiEditorTool.Align,
    TuiEditorTool.List,
    TuiEditorTool.Quote,
    TuiEditorTool.Link,
    TuiEditorTool.Anchor,
    TuiEditorTool.Color,
    TuiEditorTool.Hilite,
    TuiEditorTool.Clear,
    TuiEditorTool.Strikethrough,
    TuiEditorTool.Code,
    TuiEditorTool.Img,
    TuiEditorTool.HR,
    TuiEditorTool.Sup,
    TuiEditorTool.Sub,
    TuiEditorTool.Table,
    TuiEditorTool.Details,
];

const TUI_DEFAULT_HTML5_MEDIA_ATTRIBUTES = [
    `id`,
    `class`,
    `src`,
    `style`,
    `controls`,
    `loop`,
    `muted`,
    `preload`,
    `autoplay`,
    `width`,
    `height`,
    `controlsList`,
];

function tuiDefaultFontOptionsHandler(texts) {
    return [
        {
            px: 13,
            name: texts.small,
        },
        {
            px: 15,
            name: texts.normal,
        },
        {
            px: 17,
            name: texts.large,
        },
        {
            px: 24,
            family: `var(--tui-font-heading)`,
            name: texts.subtitle,
            headingLevel: 2,
            weight: `bold`,
        },
        {
            px: 30,
            family: `var(--tui-font-heading)`,
            name: texts.title,
            headingLevel: 1,
            weight: `bold`,
        },
    ];
}

const TUI_EDITOR_LINK_HASH_PREFIX = `#`;
const TUI_EDITOR_LINK_HTTP_PREFIX = `http://`;
const TUI_EDITOR_LINK_HTTPS_PREFIX = `https://`;
const TUI_EDITOR_LINK_SIMPLE_PROTOCOL_DIVIDER = `:`;
const TUI_EDITOR_LINK_OSI_PROTOCOL_DIVIDER = `://`;
const TUI_DEFAULT_LINK_OPTIONS = {
    protocol: TUI_EDITOR_LINK_HTTPS_PREFIX,
};

/**
 * Generated bundle index. Do not edit.
 */

export { EDITOR_BLANK_COLOR, TUI_DEFAULT_HTML5_MEDIA_ATTRIBUTES, TUI_DEFAULT_LINK_OPTIONS, TUI_EDITOR_LINK_HASH_PREFIX, TUI_EDITOR_LINK_HTTPS_PREFIX, TUI_EDITOR_LINK_HTTP_PREFIX, TUI_EDITOR_LINK_OSI_PROTOCOL_DIVIDER, TUI_EDITOR_LINK_SIMPLE_PROTOCOL_DIVIDER, defaultEditorColors, defaultEditorTools, tuiDefaultFontOptionsHandler };
